const initCartControl = () => {

    document.addEventListener("DOMContentLoaded", function () {
        
        var cartBtn = document.getElementsByClassName("cart-button");
        if (document.getElementById('lblCartItems').textContent != '0') {
            cartBtn[0].classList.add('cart-button-full');
        } else {
            cartBtn[0].classList.remove('cart-button-full');
        }
    });

};

export {
    initCartControl
};
